import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		name: 'A.I. for Microgrids'
	}
});

export default app;